import React, { ReactElement, useEffect } from 'react';
import { Content } from './Content';
import { useUILogic } from '../../shared/providers/UILogicProvider/hooks';

interface RecoveryResetPageProps {
  resetPasswordToken?: string;
  email?: string;
}

function RecoveryResetPage({ resetPasswordToken, email }: RecoveryResetPageProps): ReactElement {
  const { authorizationUiModule } = useUILogic();

  useEffect(() => {
    if (!resetPasswordToken) {
      authorizationUiModule.module.openLoginPage();
    }
  }, [resetPasswordToken, authorizationUiModule]);

  if (!resetPasswordToken) {
    return <></>;
  }

  return <Content resetPasswordToken={resetPasswordToken} email={email} />;
}

export { RecoveryResetPage };
